import React, { useState } from 'react';
import { Item } from '@/stores/canvasStore';
import { ImageLightbox } from '@/components/modals/ImageLightbox';
import { ImageIcon } from 'lucide-react';

interface ImageCardProps {
  item: Item;
}

export function ImageCard({ item }: ImageCardProps) {
  const content = item.content as { url?: string; alt?: string; mimeType?: string };
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [hasError, setHasError] = useState(false);

  // Check if this is a GIF
  const isGif = content.mimeType === 'image/gif' || 
    content.url?.toLowerCase().endsWith('.gif') || 
    content.alt?.toLowerCase().endsWith('.gif');

  const handleDoubleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (content.url) {
      setIsLightboxOpen(true);
    }
  };

  if (!content.url || hasError) {
    return (
      <div className="w-full h-full bg-muted rounded-lg card-shadow flex items-center justify-center border border-border">
        <ImageIcon className="w-12 h-12 text-muted-foreground" />
      </div>
    );
  }

  return (
    <>
      <div
        className="w-full h-full rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow relative"
        onDoubleClick={handleDoubleClick}
      >
        {isGif && (
          <span className="absolute top-2 left-2 bg-black/70 text-white text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wide z-10">
            GIF
          </span>
        )}
        <img
          src={content.url}
          alt={content.alt || 'Image'}
          className="w-full h-full object-cover rounded-lg"
          onError={() => setHasError(true)}
          draggable={false}
        />
      </div>
      
      <ImageLightbox
        url={content.url}
        alt={content.alt}
        isOpen={isLightboxOpen}
        onClose={() => setIsLightboxOpen(false)}
      />
    </>
  );
}
